import React from 'react';
import {
  Grid,
  Typography,
} from "@mui/material";
import StepperComp from './StepperComp';
import Button from '../../components/Button'
import StarIcon from "@mui/icons-material/Star";

const Details = (props) => {
  const { item } = props;
  const dateTime = `Execution 
              \n Date & Time`;

  return (
    <Grid style={{ boxShadow: 8 }}>
      <Grid display='flex' alignItems='center' marginLeft='20%' paddingTop='5%' style={{ width: '60%', justifyContent: 'center' }}>
        <Typography style={{ whiteSpace: 'nowrap' }}>Job status</Typography>
        <StepperComp style={{ width: '30%' }} active={props.executed} steps={['Job Created', 'Quote Accepted', 'Quote Revision', 'Job Executed']} />
      </Grid>
      <Grid display='flex' className="details">
        <Grid style={{ margin: '2% 5% 1% 3%' }}><img style={{ height: '70px' }} src={item.profile} alt="visibility" /></Grid>
        <Grid display='flex' flexDirection='column' marginLeft='-10%' >
          <Typography style={{ fontWeight: '600' }}>{item.firstName}</Typography>
          <Typography>{item.lastName}</Typography>
          <Typography style={{ color: '#888888' }}>{item.distance}</Typography>
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            color="#888888"
          >
            <Typography
              display="flex"
              alignItems="center"
              style={{
                fontSize: "14px",
              }}
            >
              Rating :{" "}
              <span style={{ color: "black", padding: "0px 5px" }}>
                {item?.rating}
              </span>
              <StarIcon
                style={{
                  fontSize: "18",
                  color: "#0d4f57",
                }}
              />{" "}
            </Typography>

            <Typography
              style={{
                fontSize: "14px",
                marginRight: '15px',
                marginLeft: '10px'
              }}
            >
              Reviews : <span style={{ color: "black" }}>{item?.review}</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid display='flex'>
          <Typography style={{ color: '#0D5C75' }}>{dateTime} :</Typography>
          <Typography><span> &nbsp; </span> {item.executionDate} <span style={{ color: '#0D5C75' }}> &#124; </span> {item.time}</Typography>
        </Grid>
        <Grid style={{ margin: '10px 50px' }}>
          <Button
            color="green"
            opacity="1"
            name="View Profile"
            onClick={() => {
              console.log('')
            }}
          />
        </Grid>
      </Grid>

    </Grid>

  )
}

export default Details;